// SCSS imports
// --------------------------------------------------------

import '../scss/index.scss';

// JS imports
// --------------------------------------------------------

import { initDarkMode } from './darkMode';
import { changePostCardView, copyToClipboard, togglePlan, addClassToElement } from './utils';
import { initMobileMenu, initMobileSubmenus } from './mobileMenu';
import { initSubmenu } from './submenu';
import { initDropdown } from './dropdown';
import { initProgressBar } from './progressBar';
import { initComments } from './comments';
import { initHeader } from './header';

// Set "position: sticky" last element in sidebar
// --------------------------------------------------------

const sidebars = document.querySelectorAll('main aside');

sidebars.forEach((sidebar) => {
  addClassToElement(sidebar.lastElementChild, 'last-elem');
});

// Set dark mode colors for comments block on post page
// --------------------------------------------------------

initComments();

// Toggle plan on membership page Script
// --------------------------------------------------------

togglePlan();

// Mobile menu scripts
// --------------------------------------------------------

initMobileSubmenus();
initMobileMenu();

// Copy to clipboard button script
// --------------------------------------------------------

copyToClipboard();

// Dark Mode Script
// --------------------------------------------------------

initDarkMode();

// Submenu Script
// --------------------------------------------------------

initSubmenu();

// Dropdown Script
// --------------------------------------------------------

initDropdown();

// Dropdown Script
// --------------------------------------------------------

initHeader();

// Progress Bar script
// --------------------------------------------------------

initProgressBar();

// Main code
// --------------------------------------------------------

// LoadMore script

let nextUrl = document.head.querySelector('link[rel="next"]')?.href;

function renderListPosts(postsArray, containerSelector) {
  postsArray.forEach((postCard) => {
    if (postCard.classList.contains('post-card-big')) {
      changePostCardView(postCard, 'post-card-big', 'post-card-list');
    }

    document.querySelector(containerSelector).append(postCard);
  });
}

function renderDefaultPosts(postsArray, containerSelector) {
  postsArray.forEach((postCard) => {
    document.querySelector(containerSelector).append(postCard);
  });
}

const loadMorePosts = async (loadMoreButton, postsContainerSelector, renderPostsFunction) => {
  loadMoreButton.classList.add('loading');

  if (nextUrl) {
    try {
      const response = await fetch(nextUrl);

      if (response.ok) {
        const responseText = await response.text();
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const posts = html.querySelectorAll(`${postsContainerSelector} article`);
        const nextPageUrl = html.querySelector('link[rel="next"]')?.href;

        renderPostsFunction(posts, postsContainerSelector);

        //Update the next page link in the document head
        if (nextPageUrl) {
          nextUrl = nextPageUrl;
        } else {
          loadMoreButton.style.display = 'none';
        }

        loadMoreButton.classList.remove('loading');
      } else {
        console.error('Error HTTP: ' + response.status);
      }
    } catch (error) {
      console.error(error);
    }
  }
};

const listLoadMoreBtn = document.querySelector('.list .load-more-btn');
const archiveLoadMoreBtn = document.querySelector('.archive .load-more-btn');
const gridLoadMoreBtn = document.querySelector('.grid-without-tabs .load-more-btn');

if (listLoadMoreBtn) {
  listLoadMoreBtn.addEventListener('click', function () {
    loadMorePosts(this, '.list .list__posts', renderListPosts);
  });
}

if (archiveLoadMoreBtn) {
  archiveLoadMoreBtn.addEventListener('click', function () {
    loadMorePosts(this, '.grid-without-tabs__posts', renderDefaultPosts);
  });
}

if (gridLoadMoreBtn) {
  gridLoadMoreBtn.addEventListener('click', function () {
    loadMorePosts(this, '.grid-without-tabs__posts', renderDefaultPosts);
  });
}

// TABS

let nextUrlForTabs = document.head.querySelector('link[rel="next"]')?.href;
const sectionWithTabs = document.querySelector('.grid-with-tabs__posts');

const loadMorePostsForTabsSection = async (loadMoreBtn) => {
  if (nextUrlForTabs) {
    try {
      loadMoreBtn.classList.add('loading');
      const page = await getPage(nextUrlForTabs);
      const posts = Array.from(page.querySelectorAll('.list__posts article'));
      nextUrlForTabs = page.head.querySelector('link[rel="next"]')?.href;

      if (!nextUrlForTabs) {
        loadMoreBtn.style.display = 'none';
      }

      renderPostsInSection(sectionWithTabs, posts);

      loadMoreBtn.classList.remove('loading');
    } catch (error) {
      console.error(error);
    }
  }
};

const getPage = async (url) => {
  const response = await fetch(url);
  if (response.ok) {
    const responseText = await response.text();
    const html = new DOMParser().parseFromString(responseText, 'text/html');

    return html;
  } else {
    console.log(response.status);
  }
};

const clearPostsInSection = (section) => {
  if (section) {
    section.textContent = '';
  }
};

const renderPostsInSection = (section, posts) => {
  let newPosts = '';

  posts.forEach((post) => {
    if (post.classList.contains('post-card-big')) {
      changePostCardView(post, 'post-card-big', 'post-card');
    }

    if (post.classList.contains('post-card-list')) {
      changePostCardView(post, 'post-card-list', 'post-card');
    }

    newPosts += post.outerHTML;
  });

  section.insertAdjacentHTML('beforeend', newPosts);
};

//Initializes the filter functionality for posts, allowing users to filter posts by tags and clear selected filters.
const initTabs = () => {
  const tabs = document.querySelectorAll('.tabs .tab');
  const filterWrapper = document.querySelector('.tabs');
  let prevActiveTab = document.querySelector('.tab--active');

  if (!tabs.length) {
    return;
  }

  tabs.forEach((tag) => {
    tag.addEventListener('click', async function () {
      const tagUrl = this.getAttribute('data-tab-filter-url');
      const btnLoad = document.querySelector('.grid-with-tabs .load-more-btn');

      if (!this.classList.contains('tab--active')) {
        if (prevActiveTab) {
          prevActiveTab.classList.remove('tab--active');
        }
        prevActiveTab = this;

        this.classList.add('tab--loading');
        filterWrapper.classList.add('tabs--loading');

        const page = await getPage(tagUrl);
        const posts = Array.from(page.querySelectorAll('.list__posts article'));
        nextUrlForTabs = page.head.querySelector('link[rel="next"]')?.href;

        clearPostsInSection(sectionWithTabs);

        if (!btnLoad) {
          renderPostsInSection(sectionWithTabs, posts.slice(0, 8));
        } else {
          renderPostsInSection(sectionWithTabs, posts);
        }

        if (btnLoad && nextUrlForTabs) {
          btnLoad.style.display = 'block';
        }

        if (btnLoad && !nextUrlForTabs) {
          btnLoad.style.display = 'none';
        }

        this.classList.remove('tab--loading');
        this.classList.add('tab--active');
        filterWrapper.classList.remove('tabs--loading');
      }
    });
  });
};

const initLoadMoreBtn = () => {
  const loadMoreButton = document.querySelector('.grid-with-tabs .load-more-btn');

  if (!loadMoreButton) {
    return;
  }

  loadMoreButton.addEventListener('click', async (e) => {
    e.preventDefault();
    loadMorePostsForTabsSection(loadMoreButton);
  });
};

initLoadMoreBtn();
initTabs();